var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.117 0.919922C13.907 0.919922 14.204 0.975922 14.497 1.13192C14.73 1.25692 14.914 1.44092 15.039 1.67492C15.195 1.96692 15.251 2.26392 15.251 3.05492V13.2849C15.251 14.0759 15.195 14.3729 15.039 14.6649C14.9165 14.8963 14.7273 15.0855 14.496 15.2079C14.204 15.3639 13.907 15.4199 13.116 15.4199H2.88695C2.09595 15.4199 1.79895 15.3639 1.50695 15.2079C1.27559 15.0855 1.0864 14.8963 0.963953 14.6649C0.807953 14.3729 0.751953 14.0759 0.751953 13.2849V3.05592C0.751953 2.26492 0.807953 1.96792 0.963953 1.67592C1.08895 1.44192 1.27295 1.25792 1.50695 1.13292C1.79895 0.976922 2.09595 0.920922 2.88695 0.920922L13.117 0.919922Z",
    stroke: "#F8F6F6",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.16992H15V5.16992H1V1.16992Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.16992H15V5.66992H1V4.16992Z",
    fill: "#F8F6F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.16992H5.5V15.1699H4V4.16992Z",
    fill: "#F8F6F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.86018d078a748421a9aeb61b03230af1.svg";
export { ForwardRef as ReactComponent };